import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100 pt-12 pb-8 mt-20">
      <div className="max-w-7xl mx-auto px-4">
        <ul className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8">
          <li>
            <Link to="/" className="text-gray-500 hover:text-[#0a5640] font-medium transition-colors">
              Home
            </Link>
          </li>
          <li>
            <Link to="/apply" className="text-gray-500 hover:text-[#0a5640] font-medium transition-colors">
              Apply
            </Link>
          </li>
          <li>
            <Link to="/about-us" className="text-gray-500 hover:text-[#0a5640] font-medium transition-colors">
              About us
            </Link>
          </li>
          <li>
            <a
              className="text-gray-500 hover:text-[#0a5640] font-medium transition-colors"
              href="https://quikpayasp.com/ndus/ndsu/commerce_manager/payer.do?orderType=NDSU_Spectrum_Display"
              target="_blank"
              rel="noreferrer"
            >
              Pay for Advertising
            </a>
          </li>
        </ul>
        <div className="text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} NDSU Spectrum. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
